// extracted by mini-css-extract-plugin
export default {"outer":"file_dropzone_outer__TFNJ7","dropzone":"file_dropzone_dropzone__gxl7E","selectedFiles":"file_dropzone_selectedFiles__i4Pg5"};